const AccountApiConstants = {
    GET_CART_COUNT: 'cart/items',
    SESSION: 'session',
    SESSION_CHECKOUT: 'session?context=checkout',
    CAM_BASE: 'accounts',
    EVENTS: 'events',
    ADDRESSES: 'addresses',
    ADDRESSES_UPDATE_CREATE: 'ext',
    PAYMENT_METHODS: 'payment-methods',
    STORES: 'stores',
    STORES_DEFAULT: 'stores/default',
    OAUTH_TOKEN_URL: 'oauth2/token',
    OAUTH_GUEST_TOKEN_URL: 'oauth2/guest',
    OAUTH_LOGOUT_URL: 'oauth2/logout',
    REWARDS_TOKEN: 'rewards-token',
    REWARDS_PROFILE: 'rewards-profile',
    EMAIL_ADDRESSES: 'email-addresses',
    SKU_ID_ERR_CODE: 'REG001',
    SKU_ID_ERR: 'Sku id not found',
    SKU_ID_LENGTH_ERR_CODE: 'REG002',
    SKU_ID_LENGTH_ERR: 'Sku id length is invalid',
    PRODUCT_ID_ERR_CODE: 'REG004',
    PRODUCT_ID_ERR: 'Product id not found',
    QUANTITY_ID_ERR_CODE: 'REG005',
    MEEVO: 'scheduling',
    QUANTITY_ID_ERR: 'Quantity id not found',
    REGISTRY: 'registry/items',
    PREFERENCES: 'preferences',
    ORDER_URL: 'orders',
    SAVED_ITEMS_MERGE: 'saved-items/multiple-items/myFavorites',
    ORDER_DETAILS_API_URL: 'orders/details',
    ORDERS_HISTORY_URL: 'orders/history',
    GET_ORDER_ITEMS: 'items',
    UPDATE_PAYMENT: 'billing',
    REQUEST_OTP: 'otp/generate',
    VERIFY_OTP: 'otp/verify',
    COUPONS: 'coupons',
    OPTIN: 'optin',
    SET_NEW_PASSWORD: 'accounts/password',
    WALLET: 'wallet',
    BARCODE: 'barcode',
    TENDERS: 'tenders',
    SETTINGS: 'settings',
    ELIGIBLESTORES: 'eligibleStores',
    BANNER: 'banner',
    JCP_PAYMENT_METHOD: 'payment-methods?query=cardTypes',
    QUICKSCREEN: 'quickscreen',
};

export default AccountApiConstants;
